import { Text, TextProps } from "@mantine/core"
import {
  CancelButton,
  DeleteButton,
} from "../../../../../../../../../-components/Buttons"
import { FormButtonGroup } from "../../../../../../../../../-components/form-button-group"
import { useTranslation } from "react-i18next"
import { DefaultModal } from "../../../../../../../../../-components/default-modal"

interface DeleteConfirmModalProps {
  onConfirm: () => void
  onCancel: () => void
  opened: boolean
  textProps?: TextProps
  text?: string
  deleting?: boolean
}

export function DeleteConfirmModal({
  onConfirm,
  onCancel,
  opened,
  textProps,
  text,
  deleting,
}: DeleteConfirmModalProps) {
  const { t } = useTranslation("app_server")
  return (
    <DefaultModal title={t("Delete")} opened={opened} onClose={onCancel}>
      <Text {...textProps}>
        {text ?? "Are you sure you want to delete this item?"}
      </Text>
      <FormButtonGroup>
        <CancelButton onClick={onCancel} />
        <DeleteButton loading={deleting} onClick={onConfirm} />
      </FormButtonGroup>
    </DefaultModal>
  )
}
